import React from 'react';
import CloseImg from '@assets/images/close.svg';
import styled from 'styled-components';

const ModalHeader = ({ title, close, isHeaderBolder }) => {
  return (
    <ModalHeaderContainer isHeaderBolder={isHeaderBolder}>
      <span>{title}</span>
      {close && (
        <button type="button" onClick={close} aria-label="모달 닫기">
          <img src={CloseImg} alt="" />
        </button>
      )}
    </ModalHeaderContainer>
  );
};

export default ModalHeader;

const ModalHeaderContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 4.75rem;
  padding: 1.25rem 1.5rem;

  > button {
    cursor: pointer;
    position: absolute;
    right: 1.5rem;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 50%;
    background: #f4f7f6;

    > img {
      width: 1rem;
      height: 1rem;
    }

    &:focus-visible {
      outline: 3px solid rgba(0, 190, 193, 0.2);
      outline-offset: 2px;
    }
  }

  > span {
    color: rgba(26, 31, 41, 0.89);
    font-size: 1.25rem;
    font-weight: 750;
    letter-spacing: -0.02em;
  }
  border-bottom: ${({ isHeaderBolder }) => (isHeaderBolder ? '1px solid #edf2f1' : 'none')};

  @media (max-width: 575px) {
    min-height: 4.25rem;
    padding: 1rem 1.125rem;

    > button {
      right: 1.125rem;
    }

    > span {
      font-size: 1.125rem;
    }
  }
`;
